var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.32 9.2998C43.89 9.2998 39.03 11.9398 36 15.9898C32.97 11.9398 28.11 9.2998 22.68 9.2998C13.47 9.2998 6 16.7998 6 26.0698C6 29.6398 6.57 32.9398 7.56 35.9998C12.3 50.9998 26.91 59.9698 34.14 62.4298C35.16 62.7898 36.84 62.7898 37.86 62.4298C45.09 59.9698 59.7 50.9998 64.44 35.9998C65.43 32.9398 66 29.6398 66 26.0698C66 16.7998 58.53 9.2998 49.32 9.2998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.93069b1c88f8adbf359c0982116e0b98.svg";
export { ForwardRef as ReactComponent };